const initExternalLinks = () => {
  const externalLinks = document.querySelectorAll( 'a[href^="http"]:not(.meta-nav__back-link):not(.sponsors__link)' );
  const bslVariables = bsl_variables || {}; // Passed by wp_localize_script.

  externalLinks.forEach( (link) => {
    if (link.hostname !== window.location.hostname) {
      link.setAttribute( 'target', '_blank' );
      link.setAttribute( 'rel', 'noopener noreferrer' );
      link.classList.add( 'external-link' );

      const span = document.createElement( 'span' );
      span.classList.add( 'external-link__text' );
      span.innerHTML = link.innerHTML + '<span class="sr-only"> ' + (bslVariables.opens_in_new_tab || '(opens in new tab)') + '</span>';
      link.innerHTML = '';
      link.appendChild( span );
    }
  } );
}

export default initExternalLinks;
